import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo11 } from "../../../routes/Module11";
import Imagen1 from "../../../images/modulo11/golpiza.png";

import Sidebar from "../Sidebar";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo11/Actividad 8.mp3";

const Actividad8 = () => {
  const infoUnidad = modulo11.content[0];
  const infoAct = modulo11.content[0].activities[7];
  const crumbs = [
    {
      title: modulo11.title,
      url: "/" + modulo11.url,
    },
    {
      title:
        modulo11.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo11.content[0].activities[8].name}`,
    linkNext: `${modulo11.url}/${modulo11.content[0].path}/${modulo11.content[0].activities[8].path}`,
    titlePrev: `${modulo11.content[0].activities[6].name}`,
    linkPrev: `${modulo11.url}/${modulo11.content[0].path}/${modulo11.content[0].activities[6].path}`,
  };
  const metadata = {
    color: modulo11.color,
    title: `${modulo11.title} - ${infoAct.name}`,
    name: modulo11.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo11.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <div className="row">
        <div className="col-lg-10 col-12 p-0">
          <ul>
            <li>Observa la siguiente viñeta.</li>
            <li>
              Conversa con un compañero, compañera o familiar: ¿los ciudadanos y
              ciudadanas pueden hacer lo que se muestra en la viñeta? ¿Por qué?
            </li>
          </ul>
        </div>
      </div>
      <img src={Imagen1} alt="ministerio" className="img-fluid" />

      <GuiaDocente>
        <p>
          Lea las indicaciones y observen la viñeta. Resalte que los ciudadanos
          no podemos, en ningún caso, tomar la justicia por mano propia.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad8;
